export const DATASET_INSIGHT_TYPES = {
  LINEAR_TRENDLINE: 'LINEAR_TRENDLINE',
  LOGARITHMIC_TRENDLINE: 'LOGARITHMIC_TRENDLINE',
  FORECAST_TRENDLINE: 'FORECAST_TRENDLINE',
  ANOMALY_DETECTION: 'ANOMALY_DETECTION'
};
export const Dataset = datasetPartial => Object.assign({}, datasetPartial, {
  data: datasetPartial['data'] ? datasetPartial['data'] : [],
  properties: datasetPartial['properties'] ? datasetPartial['properties'] : {}
});
export const getProperty = (dataset, property) => dataset.properties[property];
export const getPropertyLabel = (dataset, property) => {
  const propertyObj = getProperty(dataset, property);
  if (propertyObj) {
    const label = propertyObj.label;
    if (label) {
      return label;
    }
  }
  return property;
};
export const getPropertyType = (dataset, property) => {
  const propertyObj = getProperty(dataset, property);
  if (propertyObj) {
    const type = propertyObj.type;
    if (type) {
      return type;
    }
  }
  return undefined;
};
export const getReference = (dataset, property, key) => {
  const propertyObj = getProperty(dataset, property);
  if (propertyObj) {
    const reference = propertyObj.references && propertyObj.references[String(key)];
    if (reference) {
      return reference;
    }
  }
  return undefined;
};
export const getReferenceLabel = (dataset, property, key, fallback = key) => {
  const reference = getReference(dataset, property, key);
  if (reference) {
    const label = reference.label;
    if (label) {
      return label;
    }
  }
  return String(fallback);
};
export const getReferenceLink = (dataset, property, key) => {
  const reference = getReference(dataset, property, key);
  if (reference) {
    const link = reference.link;
    if (link) {
      return link;
    }
  }
  return undefined;
};

// Legacy types